import type { Chat } from '@/features/studio-renew/types'

/** 고정 검토본이 없는 구 서버 pending만 잠근다. 새 submitted 초안은 계속 편집할 수 있다. */
export function isStudioWorkLocked(
  work?: Pick<Chat, 'review' | 'internalReview'>
): boolean {
  return (
    work?.review === 'pending' &&
    (!work.internalReview || work.internalReview.reviewRevision === null)
  )
}
